(function(){
  var rollingTimer, overlay;

  function broadcastQueue(content, position, version) {
    var broadcastContent = content.reduce(function(accum, item){
      accum.pushObject({
        timestamp: item.get('timestamp'),
        description: item.get('description'),
        descriptionClass: item.get('descriptionClass')
      });
      return accum;
    }, []);

    PegasusTemplate.lookupController('frameCommManager').send('sendHistory', {
      position: position,
      version: version,
      content: broadcastContent
    });
  }

  PegasusTemplate.CommandManager = Em.ArrayController.extend({
    broadcastCurrent: function(){
      broadcastQueue( this.get('content'), this.get('position'), this.get('version') );
    },

    addObject: function(object){
      this.set('content', this.get('content').slice( 0, this.get('position') ));
      return this._super(object);
    },

    version: 0,

    position: 0,
    rollTo: function(idx){
      var commands = this.get('content'),
        position = this.get('position'),
        iterativeFunction;

      if ( position === idx ) { return; }

      if ( this.get('isRolling') ) { return; }

      PegasusTemplate.lookupController('blockOperations').set('content', null);

      this.set('isRolling', true);

      if ( idx > position ) {

        commands = commands.slice( position, idx );

        this.set('executeQueue', commands);

        this.executeNext();

      } else {

        commands = commands.slice( idx, position ).reverse();

        this.set('unexecuteQueue', commands);

        this.unexecuteNext();

      }

    },

    // keep executions in sync by waiting for a respective callback
    // before (un)executing the next command
    executeQueue: [],
    unexecuteQueue: [],

    executeNext: function(){
      var q = this.get('executeQueue');
      if ( !q.get('length') ) {
        this.broadcastCurrent();
        Em.run.scheduleOnce('afterRender', this, 'set', 'isRolling', false);
        return;
      }
      this.blockInteraction();
      this.get('executeQueue.firstObject').execute();
    },

    unexecuteNext: function(){
      var q = this.get('unexecuteQueue');
      if ( !q.get('length') ) {
        this.broadcastCurrent();
        Em.run.scheduleOnce('afterRender', this, 'set', 'isRolling', false);
        return;
      }
      this.blockInteraction();
      this.get('unexecuteQueue.firstObject').unexecute();
    },

    rollback: function(){
      if ( this.get('canRollback') ){
        this.rollTo( this.get('position') - 1 );
      }
    },
    rollforward: function(){
      if ( this.get('canRollforward') ){
        this.rollTo( this.get('position') + 1);
      }
    },
    didUnexecute: function(command){
      this.decrementProperty('position');
      if ( this.get('controller') ){
        this.get('controller').send('didUnexecute');
      }
      this.get('unexecuteQueue').removeObject( this.get('unexecuteQueue.firstObject') );
      Em.run.next(this, 'unexecuteNext');
    },
    didExecute: function(command){
      this.incrementProperty('position');
      if ( this.get('controller') ){
        this.get('controller').send('didExecute');
      }
      this.get('executeQueue').removeObject( this.get('executeQueue.firstObject') );
      Em.run.next(this, 'executeNext');
    },
    isMostRecent: function(){
      return this.get('position') === (this.get('content.length') - 1);
    }.property('position', 'content.length'),
    canRollforward: function(){
      return !this.get('isRolling') &&
        this.get('content.length') &&
        this.get('position') < this.get('content.length');
    }.property('position', 'content.length', 'isRolling'),
    canRollback: function(){
      return !this.get('isRolling') && !!( this.get('position') );
    }.property('position', 'content.length', 'isRolling'),
    blockInteraction: function(callback){
      var translation = Em.I18n.t('g.loading');
      var mask = $('.loader-mask').length ? $('.loader-mask') : $('<div class="loader-mask"><div class="loading-wrapper"><div class="loading show">'+translation+'...</div></div></div>');
      mask.remove().appendTo('body');

      Em.run.cancel( window.rollingTimer );

      if ( callback ) {
        // Firefox needs an insane amount of time to paint the mask
        Em.run.later(null, callback/*passed callback should bind context*/, 100);
        return;
      }

      // We add/remove overflow setting for the `gg` email-style-wrapper
      window.rollingTimer = Em.run.later( this, function(){
        $('.loader-mask').remove();
        Em.run.later( $(window), 'trigger', 'frameChanged', 1000 );
      }, 500);
    }
  });

  PegasusTemplate.CommandManager.reopenClass({
    reset: function(index){
      var instance = Em.get(this, 'instance');
      instance.clear();
      instance.set('position', 0);
    },

    create: function(args){
      var instance =  Em.get( this, 'get', 'instance');
      if (instance){
        return instance;
      }

      instance = this._super(args);
      Em.set(this, 'instance', instance);
      return instance;
    }
  });
})();
